var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExchange2 = function SvgExchange2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#004280",
    fillRule: "evenodd",
    d: "M3.333 6.02c0-.736.597-1.333 1.334-1.333h4.666c.736 0 1.333.597 1.333 1.334v4.645a1.333 1.333 0 0 1-2.666 0V8.945A10.62 10.62 0 0 0 5.333 16c0 5.89 4.776 10.667 10.667 10.667.816 0 1.61-.092 2.371-.265a1.333 1.333 0 0 1 .59 2.6c-.953.217-1.945.331-2.961.331-7.364 0-13.333-5.97-13.333-13.333 0-3.3 1.199-6.319 3.183-8.646H4.667A1.333 1.333 0 0 1 3.333 6.02",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B0C9E2",
    fillRule: "evenodd",
    d: "M16 5.333c-.816 0-1.61.092-2.371.265a1.333 1.333 0 1 1-.59-2.6c.953-.217 1.945-.331 2.961-.331 7.364 0 13.334 5.97 13.334 13.333 0 3.31-1.207 6.337-3.201 8.667h1.2a1.333 1.333 0 0 1 0 2.666h-4.697A1.333 1.333 0 0 1 21.302 26v-4.667a1.333 1.333 0 0 1 2.667 0v1.758A10.63 10.63 0 0 0 26.667 16c0-5.892-4.776-10.668-10.667-10.668",
    clipRule: "evenodd"
  })));
};
export default SvgExchange2;